import React from "react";
import PropTypes from "prop-types";
import RawHTML from "../RawHTML";

// components
import EligibilityCriteria from "./EligibilityCriteria";
import { add } from "lodash";
// import TransportationEligibilityCriteria from "./TransportationEligibilityCriteria";

// helpers
// import { notDiseaseFund } from "../../helpers/fund";

/**
 * Convert an integer dollar amount to a USD currency including commas
 *
 * @param {*} integer
 * @returns {string} the formatted currency
 */
const numberToCurrency = (integer) => {
  return "$" + integer.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

/**
 * The CareMetx API returns an integer for the FPL level. This must be converted to a percentage.
 * e.g.
 * 2 => 200%
 * 3 => 300%
 * etc
 *
 * @param {*} integer
 * @returns {string} the formatted percentage
 */
const fpl = (integer) => {
  return `${integer.toString()}00%`;
};

/**
 * Format assistanceAmount string by wrapping non-dollar text in <small>
 */
const formatAssistanceAmount = (str) => {
  const parts = str.split(/(\$\d[\d,]*)/); // Split on dollar amounts

  return parts.map((part, index) => {
    if (/\$\d[\d,]*/.test(part)) {
      // It's a dollar amount: render as-is
      return <React.Fragment key={index}>{part}</React.Fragment>;
    } else if (part !== "") {
      // Split leading/trailing space out of the <small> to preserve spacing
      const leadingSpace = part.startsWith(" ") ? " " : "";
      const trailingSpace = part.endsWith(" ") ? " " : "";

      const coreText = part.trim();
      return (
        <React.Fragment key={index}>
          {leadingSpace}
          <small>{coreText}</small>
          {trailingSpace}
        </React.Fragment>
      );
    } else {
      return null;
    }
  });
};

const DiseaseFundInfo = ({ title, data, eligibilityCriteria, assistanceAmount, additionalAssistanceAmountInformation }) => {
  const AssistanceAmount = () => {
    return (
      <div className="u-richtext f-scale-body">
        <h2>Assistance Amount</h2>
        {assistanceAmount && assistanceAmount.trim() !== "" ? (
          <p className="f-h3">
            {formatAssistanceAmount(assistanceAmount)}
          </p>
        ) : (
          <p className="f-h3">
            {numberToCurrency(parseInt(data.Assistance_Amount, 10))} <small>per year</small>
          </p>
        )}
        {additionalAssistanceAmountInformation && additionalAssistanceAmountInformation.trim() !== "" ? (
          <RawHTML html={ additionalAssistanceAmountInformation } />
        ) : (
          <p>
            Patients may apply for additional assistance at the end of their
            eligibility period, subject to the availability of funding.
          </p>
        )}
      </div>
    );
  };

  return (
    <div className="l-padding">
      <div className="l-wrap">
        <div className="l-2-cols disease-additional-information">
          <div className="l-col">
            <AssistanceAmount />
          </div>
          <div className="l-col">
            <EligibilityCriteria
              fpl={fpl}
              title={title}
              data={data}
              eligibilityCriteria={eligibilityCriteria}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

DiseaseFundInfo.propTypes = {
  title: PropTypes.string.isRequired,
  data: PropTypes.object.isRequired,
  assistanceAmount: PropTypes.string,
  additionalAssistanceAmountInformation: PropTypes.string
};

export default DiseaseFundInfo;
